export default __webpack_public_path__ + "static/media/stranger_hacks.d755f245.png";